export const VP_API_END_POINTS = {
  downloadApp: 'download-desktop-app',
};
